export default __webpack_public_path__ + "static/media/avan-reactjs.42b0331b.png";